import { Avatar } from '@mui/material';

import { useUserDetails } from '../../api/useUserDetails';

import { AcAvatarProps } from './AcAvatar.types';

import './style.scss';

const AcAvatar = ({ content, isSuperAdmin, dataTestId }: AcAvatarProps) => {
  const { userDetails } = useUserDetails();

  return (
    <div className={isSuperAdmin ? 'ac-avatar--super-admin' : 'ac-avatar'}>
      <Avatar sx={{ bgcolor: '#A7DAFD', color: 'black' }} data-testid={dataTestId}>
        {content
          ? content
          : userDetails?.firstName && userDetails?.lastName
            ? `${userDetails.firstName
                .charAt(0)
                .toUpperCase()}${userDetails.lastName.charAt(0).toUpperCase()}`
            : `N/A`}
      </Avatar>
    </div>
  );
};

export default AcAvatar;
